import { render, staticRenderFns } from "./LearnCreate.vue?vue&type=template&id=1f91a1f5&"
import script from "./LearnCreate.vue?vue&type=script&lang=js&"
export * from "./LearnCreate.vue?vue&type=script&lang=js&"
import style0 from "./LearnCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports